export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export type DAYS = (typeof DAYS)[keyof typeof DAYS];

export enum Language {
  English = 'ENG',
  Spanish = 'ESP',
  French = 'FRA',
  Portuguese = 'PRT',
  Chinese = 'CHN',
  Korean = 'KOR',
  Japanese = 'JPN',
  Arabic = 'ARA',
  Hebrew = 'HEB',
  Russian = 'RUS',
  Romanian = 'ROU',
  Greek = 'GRC',
  Italian = 'ITA',
  German = 'DEU',
  Armenian = 'ARM',
  Tagalog = 'TGL',
  Creole = 'CRP',
}
